module.exports = __webpack_public_path__ + "img/groupBackground.f6328b6e.png";